import { envUrl } from '@babylon/babylon-env'

export const ADMIN_PORTAL_FRAME_LEGACY_PORTAL_URL = envUrl(
  'ADMIN_PORTAL_FRAME_LEGACY_PORTAL_URL',
  'https://app-uk/',
  {
    prod: 'https://app/',
  }
)
